let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3phC6")).then(() => parcelRequire('cxEzV'));